<template>
  <div>
    <div>
      <div class= "input-add-filter-container">
      <input class="input-add" :class="{ 'input-add-mobile': mobile }" :placeholder="placeholder" @input="changed" @focus="select($refs.input, input)" :disabled="isDisabled" ref="input" type="text" v-model="input" @click="select($refs.input, input)" :maxlength="maxSizeTag"/>
      <i class="plus-icon fas fa-plus"></i>
    </div> 
  </div> 

    <div class="dropdown-content" :class="{ 'dropdown-content-mobile': mobile }" v-if="showTags" id="tagsToSelect">
        <div v-for="(tag) in filteredTags" :key="tag">
          <button class= "dropdown-content-tag tooltip" @click="addTag(tag.name)">{{ tag.name }}
            <span v-if="tag.description != null" class="tooltiptext">{{ tag.description }}</span>
          </button>
        </div>
    </div>
  </div>

</template>

<script>
// https://stackoverflow.com/questions/36170425/detect-click-outside-element
import firebase from '@/firebase'

export default {
  name: 'TagsCollection',

  props: {
    prefix: {
      type: String,
      default: 'noprefix'
    },
    hasToPopupLogin: {
      type: Boolean,
      default: false,
    },
     maxSizeTag: {
      type: Number,
      default: 40
    },
    maxTags: {
      type: Number,
      default: 3
    },
    ignoreMaxTags: {
      type: Boolean,
      default: false,
    },
    placeholderActive: {
      type: String,
      default: 'Search filter'
    },
    placeholderInactive: {
      type: String,
      default: 'Max tags reached'
    },
  },

  mounted() {
    this.suscribeHtmlClick()
    firebase.firestore.collection("tags")
        .get()
        .then((snapshot) => {
          snapshot.forEach(async (doc) => {
            this.tagsToSelect.push(doc.data())
          })
        })
        .catch((error) => {
          console.error("Error getting documents: ", error)
        })
  },

  data() {
    return {
      mobile: false,
      showTags: false,
      tagsToSelect: [],
      input: '',
      tags: [],
      isDisabled: false,
    }
  },

  computed: {
    placeholder() {
      if(this.isDisabled){
        return this.placeholderInactive
      }

      return this.placeholderActive
    },

    filteredTags() {
      const trimed = this.input.trim().split(' ')
      const result = this.tagsToSelect.filter((t) => {
        if(this.tags.indexOf(t.name.toLowerCase()) !== -1) {
          return false
        }

        let matched = 0
        const toMatch = trimed.length

        for(let x of trimed) {
          const lower = x.toLowerCase()
          if(t.name.toLowerCase().includes(lower)){
            matched++
            continue
          }
          if(t.description == null){
            continue;
          }
          if(t.description.toLowerCase().includes(lower)) {
            matched++
            continue
          }
        }
        return matched >= toMatch
      })

      return result
    }
  },

  methods: {
    changed(e){
      this.input = e.target.value
    },
    focus(){
      this.select(this.$refs.input, this.input)
    },
    suscribeHtmlClick() {
      document.addEventListener('mousedown', e => {
        const target = document.querySelector('#tagsToSelect')
        if(target == null){
          return
        }
        const isInside = !target.contains(e.target)
        if(isInside){
          this.showTags = false
        }
      })
    },
    
    addTag(tag) {
      const exist = this.tags.indexOf(tag) > -1
      if(exist){
        return
      }

      if(this.hasToPopupLogin){
        if(this.tags.length === 1 && firebase.auth.currentUser == null){
          this.$emit('show-login')
          return
        }
      }

      this.$emit('added-tags', tag.toLowerCase())
      this.tags.push(tag.toLowerCase())
      this.input = ''
      this.$refs.input.blur()

      if(!this.ignoreMaxTags){
        this.isDisabled = this.maxTags <= this.tags.length
      }
      this.$forceUpdate()
    },

    removeTag(tag) {
      const i = this.tags.indexOf(tag) 
      const exist = i > -1
      if (exist) {
        this.tags.splice(i, 1);
      }

      this.isDisabled = this.maxTags <= this.tags.length
      this.$forceUpdate()
    },

    select(ref, model) {
      this.showTags = true
      ref.focus()
      ref.setSelectionRange(0, model.length)
    },
  },
}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: var(--secondary-light-color);
  color: var(--primary-text-color);
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}

</style>
